(function () {
    'use strict';

    angular
        .module('FormBuilder')
        .directive('fbFieldRankchoice', fbFieldRankchoiceDirective);

    const defaultTemplateUrl = 'common/app/components/form/question-set/column/rankchoice';

    function fbFieldRankchoiceDirective($templateCache, lodash) {
        return {
            restrict: 'EA',
            scope: {
                element: "=",
                model: '='
            },
            template: function (elem, attr) {
                console.log(arguments);
                var templateUrl = lodash.get(attr, 'template', '');
                if (lodash.isEmpty(templateUrl)) {
                    return $templateCache.get(defaultTemplateUrl);
                }
                var template = $templateCache.get(templateUrl);
                if (lodash.isEmpty(template)) {
                    return $templateCache.get(defaultTemplateUrl);
                }
                return template;
            },
            controller: fbFieldRankchoiceDirectiveCtrl,
            controllerAs: 'vm',
            bindToController: true
        };
    }

    function fbFieldRankchoiceDirectiveCtrl(lodash, FbQuestionWrapperService, ActionManager, GenericModel) {
        var vm = this;
        this.$onInit = function() {
            vm.selectable = true;
            vm.setModel = setModel;
            vm.isSelected = isSelected;
            vm.indexOfSelected = indexOfSelected;
            vm.getRankByChoice = getRankByChoice;
            vm.clearSelection = clearSelection;
            vm.setOthersModel = setOthersModel;
            vm.updateOthers = updateOthers;
            vm.model = {answer: []};
            vm.maximumSelection = '';

            init();
        }

        function init() {
            var choice_keys = lodash.get(vm.element, 'options.settings.choice_keys');

            if (lodash.has(vm.element, 'options.choices')) {
                vm.choices = angular.copy(vm.element.options.choices);
                restrictKeys(choice_keys);
                addOthers();
            }

            if (lodash.has(vm.element, 'options.settings.choice_datasource')) {
                vm.isLoading = true;
                var callRemoteApiPromise = callRemoteApi();
                callRemoteApiPromise.then(function (res) {
                    vm.isLoading = false;
                    vm.choices = res;
                    vm.model.choices = res.map(function (_item) {
                        return _item.value;
                    });
                    restrictKeys(choice_keys);
                });
            }
        }

        function addOthers() {
            const hasOthers = lodash.get(vm, 'element.options.settings.others', false);
            if (hasOthers) {
                vm.choices = vm.choices.concat([{value: -1, label: 'Others'}]);
            }
        }

        function restrictKeys(keys) {
            if (keys) {
                vm.choices = vm.choices.map(function (choice) {
                    var modified = {};
                    keys.forEach(function (key) {
                        modified[key] = choice[key];
                    });
                    return modified;
                });
            }
        }

        if (lodash.has(vm.element, 'options.settings.showText')) {
            vm.showText = '<fb-field-show-text-field element="vm.element" model="vm.model"></fb-field-show-text-field>';
        }

        function setOthersModel(choice, $event) {
            const choiceValue = lodash.get(choice, 'value');
            const indexOfSelected = vm.indexOfSelected(choice);
            if (indexOfSelected >= 0) {
                // if (choiceValue < 0) {
                const elements = angular.element('#' + vm.element.name + '-value-' + choiceValue);
                const foundElement = lodash.first(elements);
                if (foundElement) {
                    return;
                }
                // }
            }
            setModel(choice, $event);

        }

        function updateOthers(choice, $event) {
            const choiceValue = lodash.get(choice, 'value');
            const answer = lodash.find(vm.model.answer, {value: choiceValue});
            if (answer) {
                answer.label = choice.label;
            }
        }

        function setModel(choice, $event) {
            $event.preventDefault();
            $event.stopPropagation();
            var vmModelAnswer = lodash.get(vm, 'model.answer', []);
            var _ans = angular.copy(vmModelAnswer);

            const indexOfSelected = vm.indexOfSelected(choice);
            if (indexOfSelected >= 0) {
                _ans = _ans.slice(0, indexOfSelected).concat(_ans.slice(indexOfSelected + 1));
            } else {
                const isMaxed = checkForMax(_ans.length);
                if (isMaxed) {
                    var max_selection_msg = lodash.get(vm.element, 'options.settings.max_selection_msg', null);
                    ActionManager('notify', {
                        'template': max_selection_msg,
                        'hasDelay': true,
                        'delay': 2000,
                        'type': 'warning',
                        'position': 'top center'
                    });
                    return;
                }
                _ans = lodash.concat(_ans, [choice]);
                const choiceValue = lodash.get(choice, 'value');
                if (choiceValue < 0) {
                    const elements = angular.element('#' + vm.element.name + '-value-' + choiceValue);
                    const foundElement = lodash.first(elements);
                    if (foundElement) {
                        foundElement.focus();
                    }
                }
            }

            vm.model.answer = _ans;
        }

        function indexOfSelected(choice) {
            var _ans = lodash.get(vm, 'model.answer', []);
            var choiceValue = lodash.get(choice, 'value');
            return lodash.findIndex(_ans, {value: choiceValue});
        }

        function isSelected(choice) {
            return vm.indexOfSelected(choice) >= 0;
        }

        function getRankByChoice(choice) {
            const choiceValue = lodash.get(choice, 'value');
            const answer = lodash.get(vm, 'model.answer', []);
            const foundIndex = lodash.findIndex(answer, {value: choiceValue});

            if (foundIndex >= 0) {
                return foundIndex + 1;
            }

            return '#';
        }

        function clearSelection($event) {
            $event.preventDefault();
            $event.stopPropagation();

            vm.choices.map(function (_choice) {
                if (_choice.value < 0) {
                    _choice.label = '';
                }
            })
            vm.model.answer = [];
        }

        function checkForMax(count) {
            var max_selection = lodash.get(vm.element, 'options.settings.max_selection', null);
            if (max_selection) {
                vm.maximumSelection = 'Maximum Selection';
                return count >= max_selection;
            }

            return false;
        }


        function callRemoteApi() {
            var model = new GenericModel(vm.element.options.settings.choice_datasource.url);
            var method = lodash.get(vm.element.options.settings.choice_datasource, 'method', 'get');
            return model[method]({}).$promise.then(function (res) { //res
                if (res.success && res.status_code == 200) {
                    return res.data;
                } else {
                    console.warn('Calling ' + vm.element.options.settings.choice_datasource.url + ' fails. Status code: ' + res.status_code); // eslint-disable-line no-console
                    return null;
                }
            }, function (res) {
                console.warn('Calling ' + vm.element.options.settings.choice_datasource.url + ' fails. Status code: ' + res.status_code); // eslint-disable-line no-console
                console.warn(res); // eslint-disable-line no-console
                return null;
            });
        }
    }
})();